/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';
import objectFitImages from 'object-fit-images';

// Relative Imports
import Accordion from "./modules/accordion";
import AlertBanner from "./modules/alert-banner";
import ChapterNav from './modules/chapter-nav';
import FullHeight from './modules/full-height';
import Filters from './modules/filters';
import Footer from './modules/footer';
import Footnotes from "./modules/footnotes";
import Header from './modules/header';
import PlausibleCustomAnalytics from './modules/plausible-custom-analytics';
import SocialSharing from './modules/social-sharing';
import TermsExpand from './modules/terms-expand';

(function ($) {
    const debug = true;
    const mobileBreakpoint = 767;

    /**
     * Accordion
     */
    new Accordion();

    /**
     * AlertBanner
     */
    new AlertBanner();

    /**
     * ChapterNav
     */
    new ChapterNav();

    /**
     * Header
     */
    new Header();

    /**
     * Footer
     */
    new Footer();

    /**
     * Footer
     */
    new Footnotes();

    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Full height CSS
     */
    new FullHeight();

    /**
     * Analytics
     */
    new PlausibleCustomAnalytics();

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share');

    /**
     * Terms expanding.
     */
    new TermsExpand('.js-terms-expand');

    /**
     * SVG4Everybody
     */
    new Svg4Everybody();

    /**
     * Object fit polyfill
     */
    objectFitImages();


}(jQuery));
